export default "__VITE_ASSET__CwsNAYuX__"